import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../ThemeContext';

const FeaturesHeroSection = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  return (
    <Box sx={{ position: 'relative', py: { xs: 12, md: 16 }, color: isDarkMode ? '#fff' : '#0d1530', overflow: 'hidden' }}>
      <img
        src="https://cdn.britannica.com/18/176618-050-6268BB99/David-Lean-filming-Doctor-Zhivago.jpg"
        alt="Features Hero"
        style={{
          width: '100%', height: '100%',
          position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
          objectFit: 'cover', zIndex: 0, opacity: 0.35,
        }}
      />
      {/* Dark/Light gradient overlay */}
      <Box sx={{
        position: 'absolute', inset: 0, zIndex: 1,
        background: isDarkMode
          ? 'linear-gradient(135deg, rgba(10,14,26,0.9) 0%, rgba(13,21,48,0.8) 100%)'
          : 'linear-gradient(135deg, rgba(240,244,255,0.92) 0%, rgba(255,255,255,0.88) 100%)',
      }} />
      {/* Decorative blobs */}
      <Box sx={{
        position: 'absolute', top: '20%', left: '5%', width: '300px', height: '300px',
        background: 'radial-gradient(circle, rgba(7, 164, 245,0.3) 0%, transparent 70%)',
        filter: 'blur(60px)', zIndex: 1, pointerEvents: 'none',
      }} />

      <Container sx={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
        {/* Glass card */}
        <Box
          sx={{
            display: 'inline-block',
            background: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.85)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(7, 164, 245,0.15)',
            borderRadius: '24px',
            px: { xs: 4, md: 8 },
            py: { xs: 4, md: 6 },
            boxShadow: isDarkMode ? '0 16px 48px rgba(0,0,0,0.4)' : '0 16px 48px rgba(7, 164, 245,0.12)',
            maxWidth: 600,
          }}
        >
          <Typography variant="h3" fontWeight={800} gutterBottom sx={{ color: isDarkMode ? 'white' : '#0d1530', lineHeight: 1.2 }}>
            Explore Our Powerful Features
          </Typography>
          <Box sx={{ width: 60, height: 3, background: 'linear-gradient(90deg, #07a4f5, #5dade2)', mx: 'auto', my: 2, borderRadius: '2px' }} />
          <Typography variant="body1" sx={{ color: isDarkMode ? '#b0b8c4' : '#4a5568', mb: 4, lineHeight: 1.7 }}>
            Film-Hook Mediaapp is packed with features tailored for both the Public and Film Industry. Connect, create, and collaborate like never before.
          </Typography>
          <Button
            href="https://play.google.com/store/apps/details?id=com.projectfh&hl=en"
            target="_blank"
            sx={{
              background: 'linear-gradient(90deg, #07a4f5 0%, #5dade2 100%)',
              color: 'white',
              fontWeight: 700,
              fontSize: '0.95rem',
              borderRadius: '25px',
              px: 4,
              py: 1.4,
              textTransform: 'none',
              boxShadow: '0 8px 20px rgba(7, 164, 245,0.4)',
              '&:hover': {
                background: 'linear-gradient(90deg, #068bc2 0%, #3498db 100%)',
                boxShadow: '0 8px 28px rgba(7, 164, 245,0.6)',
              },
            }}
          >
            Explore the App
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default FeaturesHeroSection;
